var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : 'div',{tag:"component",staticClass:"c-button",class:{
    'c-button--primary': _vm.isPrimary,
    'c-button--secondary': _vm.isSecondary,
    'c-button--dangerous': _vm.isDangerous,
    'c-button--floating': _vm.isFloating,
    'c-button--floating-secondary': _vm.isFloating && _vm.isSecondary,
    'c-button--small': _vm.size === 'small'
  },attrs:{"to":_vm.to ? _vm.to : null},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }